import styled from "styled-components";

/**
 * Wrapper principal do FlightCard
 * Configura o layout geral do cartão de voo.
 */
export const FlightCardWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  box-shadow: ${({ theme }) => theme.shadows.light.small};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 ${({ theme }) => theme.spacing(2)};
  margin-top: 20px;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.colorful.blue};
  }
`;

/**
 * Wrapper principal do FlightCard
 * Configura o layout geral do cartão de voo.
 */
export const FlightCardContainer = styled.div`
  transition: box-shadow 0.3s ease-in-out;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: column;
  cursor: pointer;
  display: flex;
`;

/**
 * Wrapper dos segmentos de voo
 * Contém as informações de ida e volta.
 */
export const SegmentsContainer = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  display: flex;
  flex: 2;
`;

/**
 * Wrapper do preço do voo
 * Apresenta o preço de forma destacada.
 */
export const PriceContainer = styled.div`
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  margin-bottom: 20px;
`;

/**
 * Wrapper de detalhes adicionais
 * Utilizado para exibir informações adicionais, se necessário.
 */
export const DetailsWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  background-color: ${({ theme }) => theme.colors.lightGray};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

/**
 * Botão para expandir/ocultar detalhes
 */
export const ToggleButton = styled.button`
  margin-top: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(1)};
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.mediumBlue};
  cursor: pointer;
  text-align: center;
`;
